import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
import Footer from "./footer";
import ProductLogoShowcase from "./product-logo-showcase";
import "../styles/self-hosted-fonts.css";
import "./layout.css";
import "../styles/index.scss";
import "../styles/output.css";
import "../styles/custom.scss";
import "../styles/global.css";

import { adRefCity } from "../helpers/adRefTracking";
import Navbar from "./Navbar";

const Layout = ({ children, pageProps, footerLogoShowcase, isHomePage, customSchema, headerTransparent, headerShadow }) => {
  // pageProps is optional — src/pages/thanks.js renders <Layout> without it. Fall
  // back to window.location so a first-time visitor landing straight on such a page
  // doesn't take a TypeError here and lose hydration for the whole page.
  if (typeof window !== "undefined" && window.localStorage && !window.localStorage.getItem("landingURL")) {
    try {
      const landingHref =
        (pageProps && pageProps.location && pageProps.location.href) || window.location.href;
      window.localStorage.setItem("landingURL", landingHref);
      window.localStorage.setItem("landingDate", new Date());
    } catch (e) {
      /* storage unavailable — attribution is best-effort, never fatal */
    }
  }
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              companyInfo {
                phone
                email
                addressLine1
                addressLine2
                city
                state
                zip
                license
              }
            }
          }
          allContentfulNavigation(filter: { name: { eq: "Main Navigation" } }) {
            edges {
              node {
                id
                name
                menuItems {
                  id
                  name
                  title
                  url
                  openInNewWindow
                  submenu {
                    id
                    name
                    menuItems {
                      id
                      name
                      title
                      url
                      openInNewWindow
                    }
                  }
                }
                campaign
              }
            }
          }
        }
      `}
      render={(data) => (
        <>
          <Navbar
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            pageProps={pageProps}
            headerTransparent={headerTransparent}
            shadow={headerShadow}
          />

          {/* <Header
            siteTitle={data.site.siteMetadata.title}
            siteDescription={adRefCity(data.site.siteMetadata.description)}
            companyInfo={data.site.siteMetadata.companyInfo}
            mainNavigation={
              data.allContentfulNavigation.edges.filter(
                ({ node: { campaign } }) =>
                  campaign.length > 0 ? campaign[0] === 'default' : false
              )[0].node.menuItems
            }
            menus={data.allContentfulNavigation.edges}
            pageProps={pageProps}
          /> */}

          <div className="layout-container">{children}</div>
          {footerLogoShowcase !== false ? (
            <ProductLogoShowcase footerLogoShowcase={footerLogoShowcase} />
          ) : null}
          <Footer isHomePage={isHomePage} />
          {/* Promotion modal removed from the render tree: its open trigger has
              been commented out for years, so it only shipped dead JS
              (reactjs-popup + js-cookie) on every page. Restore the import and
              element together if the promo ever comes back. */}
          {!customSchema && (
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: `
              {
                "@id": "https://roachhomeimprovement.com/#HomeAndConstructionBusiness",
                "@context": "https://www.schema.org",
                "@type": "HomeAndConstructionBusiness",
                "name": "Roach Home Improvement",
                "url": "https://roachhomeimprovement.com/",
                "logo": "https://images.ctfassets.net/seqn6hyrh7p7/47ugz3TDJq3S0Vlkz6QjRt/04a537cf23f52f952ef3dfdc0e144663/roachhomeimprovement-thumb.jpg",
                "image": "https://images.ctfassets.net/seqn6hyrh7p7/47ugz3TDJq3S0Vlkz6QjRt/04a537cf23f52f952ef3dfdc0e144663/roachhomeimprovement-thumb.jpg",
                "description": "Roach Home Improvement is a locally owned and operated full service Remodeling contractor in Battle Creek, MI specializing in roofing repair, replacement, and installation for residential and commercial projects.
                ",
                "address": {
                    "@type": "PostalAddress", 
                    "addressLocality": "Battle Creek",
                    "addressRegion": "MI",
                    "postalCode": "49017",
                    "addressCountry": "USA"
                },
  
                "openingHours": "Mo, Tu, We, Th, Fr 08:00-18:00",
                "contactPoint": {
                    "@type": "ContactPoint",
                    "contactType": "sales",
                    "telephone": "+1 269-420-6623"
                }
            }`,
              }}
            />
          )}
        </>
      )}
    />
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

//classes for tailwind to include when doing purge
// pr-2
